import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueNotify from 'vue-notifyjs';
import router from '../main.js';

Vue.use(Vuex);
Vue.use(VueAxios, axios);
Vue.use(VueNotify, { type: 'danger', timeout: 5000, horizontalAlign: 'center', verticalAlign: 'top', });

let notifier = new Vue();

const store = new Vuex.Store({
    state: {
        modal_login: false,
        modal_reg: false,
        modal_forgot: false,
        modal_gisaid: false,
        modal_info: false,
        modal_info_text: "",
        modal_interpretation: false,
        modal_transcripts: false,
        modal_new_project: false,
        modal_project_detail: false,
        modal_project_stat: false,
        modal_patient: false,
        modal_exam_qc: false,
        modal_exam_detail: false,
        modal_nextstrain: false,
        modal_subject_mongo_files: false,

        id_user: localStorage.getItem('current_user'),
        token: localStorage.getItem('token'),
        roles: [],
        my_role: 0,
        biovendor: false,

        user: {
            id_user: 0,
            email: "",
            nick: "MUDr. Sova",
            f_name: "",
            l_name: "",
            degrees_1: "",
            degrees_2: "",
            phone: "",
            last_role: 0,
            workflow_group: 0,
        },

        subject: {
            id_subject: 0,
            subject: "",
            s_type: 0,
            ic: "",
            hash: "",
            street: "",
            city: "",
            post_code: "",
            country: "",
            phone: "",
            email: "",
            dic: "",
        },

        client_img: "img/client_0.jpg",

        application: "",
        current_url: "",

        project_detail_default: {
            id_project: 0,
            name: "",
            description: "",
            id_workflow: 0,
            type: "",
            passage: "",
            location: "",
            host: "",
            assembly_method: "",
            orig_lab: "",
            orig_lab_addr: "",
            provider_sample_id: "",
            subm_lab: "",
            subm_lab_addr: "",
            authors: "",
            seq_technology: 0,
        },

        project_detail: {
            id_project: 0,
            name: "",
            description: "",
            id_workflow: 0,
            type: "",
            passage: "",
            location: "",
            host: "",
            assembly_method: "",
            orig_lab: "",
            orig_lab_addr: "",
            provider_sample_id: "",
            subm_lab: "",
            subm_lab_addr: "",
            authors: "",
            seq_technology: 0,
        },

        exam_detail_default: {
            sample_id: "",
            zip_code: "",
            description: "",
            fn: "",
            virus_name: "",
            collection_date: "",
            add_location: "",
            add_host_info: "",
            gender: 0,
            patient_age: 0,
            patient_status: "",
            speciment_source: "",
            outbreak: "",
            last_vaccinated: "",
            treatment: "",
            coverage: "",
            subm_sample_id: "",
            comment: "",
        },

        exam_detail: {
            sample_id: "",
            zip_code: "",
            description: "",
            fn: "",
            virus_name: "",
            collection_date: "",
            add_location: "",
            add_host_info: "",
            gender: 0,
            patient_age: 0,
            patient_status: "",
            speciment_source: "",
            outbreak: "",
            last_vaccinated: "",
            treatment: "",
            coverage: "",
            subm_sample_id: "",
            comment: "",
        },

        projects: [],
        id_project: 0,
        id_project_detail: 0,
        examinations: [],
        id_examination: 0,
        id_examination_detail: 0,
        examinations_workflow: [],
        examinations_subject: [],
        subject_shortcut: [],
        executions: [],
        id_execution: 0,
        id_execution_detail: 0,
        substs: [],
        vars: [],
        id_var: 0,
        var_page: 1,
        vars_order: 1,
        f_filters: [],
        u_filters: [],
        c_filter: {},
        workflows: [],
        patients: [],
        patient: {},
        id_patient: 0,
        id_patient_card: 0,
        project_files_data: [],
        project_files_others: [],
        qc_redirect: "",
        transcripts: [],

        collection: "",
        f_a: [],
        f_u: [],
        f_q: [],
        f_m: [],
        f_o: [],
        f_e: [],
        f_s: [],
        f_x: [],

        u_f_a: [],
        u_f_u: [],
        u_f_q: [],
        u_f_m: [],
        u_f_o: [],
        u_f_e: [],
        u_f_s: [],
        u_f_x: [],

        qc_a: {},

        qc_c: [],

        chart_bar_a: [],

        dabo_pan_lineage: [],
        dabo_next_clade: [],
        dabo_subjects: "",
        dabo_projects: "",
        dabo_examinations: "",
        dabo_mutations: "",
        dabo_lineages: "",


    },

    getters: {
        g_gene: (state, getters) => {
            if (state.ss_gene > "") {
                return state.l_gene.filter(one => (one.includes(state.ss_gene.toUpperCase())));
            } else {
                return [];
            }
        },

        g_project: (state, getters) => {
            if (state.id_project > 0) {
                return state.projects.filter(one => (one.id_project === state.id_project))[0];
            } else {
                return {};
            }
        },

        g_examination: (state, getters) => {
            if (state.id_examination_detail > 0) {
                return state.examinations.filter(one => (one.id_examination === state.id_examination_detail))[0];
            } else {
                return {};
            }
        },

        g_examination_sample_id: (state, getters) => {
            if (state.id_examination > 0) {
                return state.examinations.filter(one => (one.id_examination === state.id_examination))[0];
            } else {
                return {};
            }
        },

        g_examination_for_submit: (state, getters) => {
            return state.examinations.filter(one => (one.status === 1));
        },

        g_examination_vars: (state, getters) => {
            if (state.id_examination > 0) {
                let myvars = [];
                state.vars.forEach(element => myvars.push(element.id_var));
                return myvars;
            } else {
                return [];
            }
        },

        g_upload_file: (state, getters) => {
            if (state.current_url.hostname === "localhost") {
                return state.current_url.protocol + "//" + state.current_url.hostname + ":8301" + "/uploadfile";
            } else {
                return state.current_url.protocol + "//" + state.current_url.hostname + "/ra/uploadfile";
            }
        },

        g_upload_csvfile: (state, getters) => {
            if (state.current_url.hostname === "localhost") {
                return state.current_url.protocol + "//" + state.current_url.hostname + ":8301" + "/uploadcsvfile";
            } else {
                return state.current_url.protocol + "//" + state.current_url.hostname + "/ra/uploadcsvfile";
            }
        },

        g_upload_xlsx: (state, getters) => {
            if (state.current_url.hostname === "localhost") {
                return state.current_url.protocol + "//" + state.current_url.hostname + ":8301" + "/uploadxlsx";
            } else {
                return state.current_url.protocol + "//" + state.current_url.hostname + "/ra/uploadxlsx";
            }
        },

    },

    mutations: {
        m_modal_login(state, value) {
            state.modal_login = value;
        },

        m_modal_reg(state, value) {
            state.modal_reg = value;
        },

        m_modal_forgot(state, value) {
            state.modal_forgot = value;
        },

        m_modal_gisaid(state, value) {
            state.modal_gisaid = value;
        },

        m_modal_info(state, value) {
            state.modal_info = value;
        },

        m_modal_info_text(state, value) {
            state.modal_info_text = value;
            if (state.modal_info_text > '') {
                state.modal_info = true
            } else {
                state.modal_info = false
            }
        },

        m_modal_interpretation(state, value) {
            state.modal_interpretation = value;
        },

        m_modal_transcripts(state, value) {
            state.modal_transcripts = value;
        },

        m_modal_patient(state, value) {
            state.modal_patient = value;
        },

        m_token(state, value) {
            state.token = value;
        },

        m_id_user(state, value) {
            state.id_user = value;
        },

        m_login(state, { email, password }) {

        },

        m_join_subject(state, value) {
            state.roles = value;
        },

        m_subject(state, value) {
            state.subject = value;
        },

        m_biovendor(state, value) {
            state.biovendor = value;
        },


        m_user(state, value) {
            state.user = value;
        },

        m_privat_be(state, value) {
            state.privat_be = value;
        },

        m_current_url(state, value) {
            state.current_url = value;
        },

        m_hpo(state, value) {
            state.hpo = value;
        },

        m_l_hpo(state, value) {
            state.l_hpo = value;
        },

        m_l_gene(state, value) {
            state.l_gene = value;
        },

        m_ss_gene(state, value) {
            state.ss_gene = value;
        },

        m_ff_name(state, value) {
            state.ff_name = value;
        },

        m_ff_description(state, value) {
            state.ff_description = value;
        },

        m_projects(state, value) {
            state.projects = value;
        },

        m_projects_refresh(state, value) {
            value.forEach(function(member) {
                state.projects.forEach(function(project) {
                    if ((project.id_project === member.id_project) && (project.status !== member.status)) {
                        project.status = member.status;
                    }
                })
            })
        },

        m_id_project(state, value) {
            state.id_project = value;
            // state.m_f_q = [];
            // state.m_f_a = [];
            // state.m_f_u = [];
            // state.m_f_m = [];
            // state.m_f_o = [];
            // state.m_f_e = [];
            state.u_f_q = [];
            state.u_f_a = [];
            state.u_f_u = [];
            state.u_f_m = [];
            state.u_f_o = [];
            state.u_f_e = [];
            state.u_f_s = [];
            state.f_q = [];
            state.f_a = [];
            state.f_u = [];
            state.f_m = [];
            state.f_o = [];
            state.f_e = [];
            state.f_s = [];
        },

        m_id_project_detail(state, value) {
            state.id_project_detail = value;
        },

        m_project(state, value) {
            state.project = value;
        },

        m_modal_new_project(state, value) {
            state.modal_new_project = value;
        },

        m_modal_project_detail(state, value) {
            state.modal_project_detail = value;
        },

        m_modal_project_stat(state, value) {
            state.modal_project_stat = value;
        },

        m_examinations(state, value) {
            state.examinations = value;
        },

        m_examinations_workflow(state, value) {
            state.examinations_workflow = value;
        },

        m_examinations_subject(state, value) {
            state.examinations_subject = value;
        },

        m_subject_shortcut(state, value) {
            state.subject_shortcut = value;
        },

        m_examinations_refresh(state, value) {
            value.forEach(function(member) {
                state.examinations.forEach(function(examination) {
                    if ((examination.id_examination === member.id_examination) && (examination.status !== member.status)) {
                        examination.status = member.status;
                    }
                })
            })
        },

        m_id_examination(state, value) {
            state.id_examination = value;
        },

        m_modal_exam_qc(state, value) {
            state.modal_exam_qc = value;
        },

        m_modal_exam_detail(state, value) {
            state.modal_exam_detail = value;
        },

        m_modal_nextstrain(state, value) {
            state.modal_nextstrain = value;
        },

        m_modal_subject_mongo_files(state, value) {
            state.modal_subject_mongo_files = value;
        },

        m_id_examination_detail(state, value) {
            state.id_examination_detail = value;
        },

        m_qc_a(state, value) {
            state.qc_a = value;
        },

        m_qc_c(state, value) {
            state.qc_c = value;
        },

        m_chart_bar_a(state, value) {
            state.chart_bar_a = value;
        },

        m_dabo_pan_lineage(state, value) {
            state.dabo_pan_lineage = value;
        },

        m_dabo_next_clade(state, value) {
            state.dabo_next_clade = value;
        },

        m_dabo_subjects(state, value) {
            state.dabo_subjects = value;
        },

        m_dabo_projects(state, value) {
            state.dabo_projects = value;
        },

        m_dabo_examinations(state, value) {
            state.dabo_examinations = value;
        },

        m_dabo_mutations(state, value) {
            state.dabo_mutations = value;
        },

        m_dabo_lineages(state, value) {
            state.dabo_lineages = value;
        },

        m_f_a(state, value) {
            state.f_a = value;
        },

        m_f_u(state, value) {
            state.f_u = value;
        },

        m_f_q(state, value) {
            state.f_q = value;
        },

        m_f_m(state, value) {
            state.f_m = value;
        },

        m_f_o(state, value) {
            state.f_o = value;
        },

        m_f_e(state, value) {
            state.f_e = value;
        },

        m_f_s(state, value) {
            state.f_s = value;
        },

        m_collection(state, value) {
            state.collection = value;
        },

        m_substs(state, value) {
            state.substs = value;
        },

        m_vars(state, value) {
            state.vars = value;
        },

        m_vars_order(state, value) {
            state.vars_order = value;
        },

        m_slider_value(state, value) {
            state.slider_value = value;
        },

        m_er_switch(state, value) {
            state.er_switch = value;
        },

        m_var_page(state, value) {
            state.var_page = value;
        },

        m_f_filters(state, value) {
            state.f_filters = value;
        },

        m_u_filters(state, value) {
            state.u_filters = value;
        },

        m_workflows(state, value) {
            state.workflows = value;
        },

        m_patients(state, value) {
            state.patients = value;
        },

        m_patient(state, value) {
            state.patient = value;
        },

        m_id_patient(state, value) {
            state.id_patient = value;
        },

        m_id_patient_card(state, value) {
            state.id_patient_card = value;
        },

        m_patient_card_hpo_add(state, value) {
            let xxx = [];
            state.patient_card.hpo.forEach(one => xxx.push(one.hpo_id));
            if (xxx.length > 0 && xxx.includes(value.hpo_id)) {

            } else {
                state.patient_card.hpo.push(value);
            }
        },

        m_patient_card_hpo_del(state, value) {
            state.patient_card.hpo = state.patient_card.hpo.filter(member => member.hpo_id != value);
        },


        m_anots(state, value) {
            state.anots = value;
        },

        m_project_files_data(state, value) {
            state.project_files_data = value;
        },

        m_project_files_others(state, value) {
            state.project_files_others = value;
        },

        m_qc_redirect(state, value) {
            state.qc_redirect = value;
        },

        m_transcripts(state, value) {
            state.transcripts = value;
        },

        m_project_detail(state, my_id_project) {
            if (my_id_project > 0) {
                Object.assign(state.project_detail, state.projects.filter(one => (one.id_project === my_id_project))[0]);
            } else {
                Object.assign(state.project_detail, state.project_detail_default);
            }
        },

        m_project_detail_load(state, value) {
            Object.assign(state.project_detail, value);
        },

        m_exam_detail(state, my_id_examination) {
            if (my_id_examination > 0) {
                Object.assign(state.exam_detail, state.examinations.filter(one => (one.id_examination === my_id_examination))[0]);
            } else {
                Object.assign(state.exam_detail, state.exam_detail_default);
            }
        },

        m_exam_detail_subject(state, my_id_examination) {
            if (my_id_examination > 0) {
                Object.assign(state.exam_detail, state.examinations_subject.filter(one => (one.id_examination === my_id_examination))[0]);
            } else {
                Object.assign(state.exam_detail, state.exam_detail_default);
            }
        },

        m_exam_detail_workflow(state, my_id_examination) {
            if (my_id_examination > 0) {
                Object.assign(state.exam_detail, state.examinations_workflow.filter(one => (one.id_examination === my_id_examination))[0]);
            } else {
                Object.assign(state.exam_detail, state.exam_detail_default);
            }
        },

    },

    actions: {
        a_notify(context, payload) {
            notifier.$notify(payload);
        },

        a_login({ state, commit, getters }, payload) {
            axios.post(process.env.VUE_APP_BE + '/login', { email: payload.email, password: payload.password }, { withCredentials: true, headers: { 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_token', response.data["token"]);
                    if (response.data["token"] > "") {
                        // localStorage.setItem('current_user', response.data["current_user"]);
                        localStorage.setItem('token', response.data["token"]);
                        commit('m_modal_login', false);
                        commit('m_user', response.data["user"]);
                        store.dispatch('a_load_profile');
                    } else {
                        commit('m_modal_login', false);
                        commit('m_modal_info_text', "Zadané údaje neodpovídají platnému účtu. Zkuste to, prosím, znovu.");
                    }
                }, error => {
                    console.log(error);
                });

        },

        a_logout({ state, commit, getters }, payload) {
            axios.get(process.env.VUE_APP_BE + '/logout', { headers: { 'Authorization': state.token } }, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    // commit('m_id_user', response.data["current_user"]);
                    commit('m_token', "");
                    // localStorage.removeItem("current_user");
                    localStorage.removeItem("token");
                }, error => {
                    console.log(error);
                });

            // commit('m_modal_login', false);
            console.log("Logout");
            router.push("/");
        },


        a_reg({ state, commit, getters }, payload) {
            axios.post(process.env.VUE_APP_BE + '/registration', { email: payload.email, password: payload.password, degrees_1: payload.degrees_1, firstName: payload.firstName, lastName: payload.lastName, degrees_2: payload.degrees_2, phone: payload.phone }, { withCredentials: true, headers: { 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    // commit('m_id_user', response.data["current_user"]);
                    // commit('m_token', response.data["token"]);
                    if (response.data["status"] === "OK") {
                        // localStorage.setItem('current_user', response.data["current_user"]);
                        // localStorage.setItem('token', response.data["token"]);
                        commit('m_modal_reg', false);
                        commit('m_modal_info_text', "Děkujeme za registraci. Posíláme Vám email s ověřovacím odkazem pro aktivaci Vašeho účtu.");

                    } else {
                        commit('m_modal_reg', false);
                        commit('m_modal_info_text', "Zadané údaje neodpovídají platnému účtu. Zkuste to, prosím, znovu.");
                    }
                }, error => {
                    console.log(error);
                });

        },


        a_join_subject({ state, commit, getters }, payload) {
            axios.get(process.env.VUE_APP_BE + '/join_subject', { headers: { 'Authorization': state.token } }, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_join_subject', response.data["roles"]);
                    router.push("/join_subject");
                }, error => {
                    console.log(error);
                });
        },

        a_load_profile({ state, commit, getters }, payload) {
            axios.get(process.env.VUE_APP_BE + '/load_profile', { headers: { 'Authorization': state.token } }, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_subject', response.data["subject"]);
                    commit('m_user', response.data["user"]);
                    if (state.current_url.hostname !== "localhost") {
                        // commit('m_privat_be', response.data["subject"]["privat_api"]);
                        // commit('m_privat_be', "/pv");
                    }

                }, error => {
                    console.log(error);
                });
        },


        a_my_role({ state, commit, getters }, id_role) {
            axios.post(process.env.VUE_APP_BE + '/join_subject', { id_role: id_role }, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_projects', []);
                    commit('m_id_project', 0);
                    commit('m_examinations', []);
                    commit('m_id_examination', 0);
                    commit('m_vars', []);
                    commit('m_subject', response.data["subject"]);
                    if ((this.current_url) && (this.current_url.hostname === "localhost")) {
                        commit('m_privat_be', "http://localhost:8199/");
                    } else {
                        // commit('m_privat_be', response.data["subject"]["privat_api"]);
                        commit('m_privat_be', "/pv");
                    };

                    store.dispatch('a_notify', {
                        message: "You've joined into " + response.data["subject"]["subject"],
                    });

                    // commit('m_join_subject', response.data["roles"]);
                    // router.push("/join_subject");
                }, error => {
                    console.log(error);
                });
        },


        a_gisaid({ state, commit, getters }, payload) {
            axios.post(process.env.VUE_APP_BE + '/gisaid_cred', { payload }, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_modal_gisaid', false);
                }, error => {
                    console.log(error);
                });

        },


        a_test({ state, commit, getters }, payload) {
            axios.post(process.env.VUE_APP_BE + '/test', {}, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    console.log(response.data);
                }, error => {
                    console.log(error);
                });

            console.log("Logout");
        },


        a_filter_save({ state }) {
            axios.post(process.env.VUE_APP_BE + '/filter_save', { cufi: state.cufi, name: state.ff_name, description: state.ff_description }, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    console.log(response.data);
                }, error => {
                    console.log(error);
                });

            // console.log(state.cufi);
            // console.log(state.ff_name);
            // console.log(state.ff_description);
        },

        a_patients({ state, commit, getters }, payload) {
            axios.post(state.privat_be + '/patients', {}, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_patients', response.data["patients"]);
                }, error => {
                    console.log(error);
                });
        },

        a_patient({ state, commit, getters }, id_patient) {
            axios.post(state.privat_be + '/patient', { "id_patient": id_patient }, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_patient', response.data["patient"]);
                    console.log(response.data["patient"]);
                }, error => {
                    console.log(error);
                });
        },


        a_projects({ state, commit, getters }, payload) {
            axios.post(process.env.VUE_APP_BE + '/projects', { w_data: ['projects'] }, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_projects', response.data["projects"]);
                    // router.push("/join_subject");
                }, error => {
                    console.log(error);
                });
        },


        a_projects_refresh({ state, commit }) {
            axios.get(process.env.VUE_APP_BE + '/projects', { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_projects_refresh', response.data["projects_refresh"]);
                }, error => {
                    console.log(error);
                });
        },

        a_project_detail({ state, commit, getters }, payload) {
            axios.post(process.env.VUE_APP_BE + '/project_detail', { "project_detail": payload }, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_projects', response.data["projects"]);
                    commit('m_project_detail', response.data["id_project"]);
                    this.dispatch('a_notify', {
                        message: 'Project has been updated.',
                    }, { root: true });
                }, error => {
                    console.log(error);
                });
        },

        a_project_detail_get({ state, commit, getters }, payload) {
            axios.get(process.env.VUE_APP_BE + '/project_detail', { params: { "project_detail": payload }, withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_project_detail_load', response.data["project_detail"]);
                }, error => {
                    console.log(error);
                });
        },

        a_project_delete({ state, commit, getters }, payload) {
            axios.post(process.env.VUE_APP_BE + '/project_delete', { data: payload }, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    if (response.data["status"] === 1) {
                        commit('m_projects', response.data["projects"]);
                        this.dispatch('a_notify', {
                            message: 'Project has been removed.',
                        }, { root: true });
                    } else {
                        this.dispatch('a_notify', {
                            message: 'Project can not be removed.',
                        }, { root: true });
                    }
                }, error => {
                    console.log(error);
                });
        },


        a_examinations({ state, commit, getters }, payload) {
            axios.post(process.env.VUE_APP_BE + '/examinations', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_examinations', response.data["examinations"]);
                    // router.push("/join_subject");
                }, error => {
                    console.log(error);
                });
        },

        a_examination({ state, commit, getters }, payload) {
            axios.post(process.env.VUE_APP_BE + '/examination', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_examination', response.data["examination"]);
                    // router.push("/join_subject");
                }, error => {
                    console.log(error);
                });
        },

        a_examination_validate({ state, commit, getters }, payload) {
            axios.post(process.env.VUE_APP_BE + '/examination_validate', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    if (response.data["status"] === 3) {
                        this.dispatch('a_examinations', { "id_project": state.id_project });
                        this.dispatch('a_notify', {
                            message: 'Validated, the process will be started.',
                        }, { root: true });
                    } else if (response.data["status"] === 12) {
                        this.dispatch('a_examinations', { "id_project": state.id_project });
                        this.dispatch('a_notify', {
                            message: 'Validated, the examination will load variants into database now.',
                        }, { root: true });
                    } else {
                        this.dispatch('a_notify', {
                            message: 'Missing FASTQ file(s), the process is stopped.',
                        }, { root: true });
                    }
                }, error => {
                    console.log(error);
                });
        },

        a_examination_delete({ state, commit, getters }, payload) {
            axios.post(process.env.VUE_APP_BE + '/examination_delete', { data: payload }, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    if (response.data["status"] === 1) {
                        commit('m_examinations', response.data["examinations"]);
                        this.dispatch('a_notify', {
                            message: 'Examination has been removed.',
                        }, { root: true });
                    } else {
                        this.dispatch('a_notify', {
                            message: 'Examination can not be removed.',
                        }, { root: true });
                    }
                }, error => {
                    console.log(error);
                });
        },


        a_exam_detail({ state, commit, getters }, payload) {
            axios.post(process.env.VUE_APP_BE + '/exam_detail', { "exam_detail": payload, "id_examination": state.id_examination_detail }, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_examinations', response.data["examinations"]);
                    commit('m_exam_detail', response.data["id_examination"]);
                    this.dispatch('a_notify', {
                        message: 'Examination has been updated.',
                    });
                }, error => {
                    console.log(error);
                });
        },

        a_examinations_workflow({ state, commit, getters }) {
            axios.get(process.env.VUE_APP_BE + '/examinations_workflow', { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_examinations_workflow', response.data["examinations_workflow"]);
                    commit('m_subject_shortcut', response.data["subject_shortcut"]);
                }, error => {
                    console.log(error);
                });
        },

        a_examinations_subject({ state, commit, getters }) {
            axios.get(process.env.VUE_APP_BE + '/examinations_subject', { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_examinations_subject', response.data["examinations_subject"]);
                }, error => {
                    console.log(error);
                });
        },

        a_varsall({ state, commit, getters }, payload) {
            axios.post(process.env.VUE_APP_BE + '/varsall', { page: state.slider_value }, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_vars', response.data["vars"]);
                }, error => {
                    console.log(error);
                });
        },

        a_substs({ state, commit, getters }, id_examination) {
            axios.get(process.env.VUE_APP_BE + '/subs', { withCredentials: true, params: { "id_examination": id_examination }, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', }, })
                .then(response => {
                    commit('m_substs', response.data["subs"]);
                }, error => {
                    console.log(error);
                });
        },

        a_vars({ state, commit, getters }, payload) {
            axios.post(process.env.VUE_APP_BE + '/vars', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_vars', response.data["vars"]);
                }, error => {
                    console.log(error);
                });
        },

        a_f_filters({ state, commit, getters }, payload) {
            axios.post(process.env.VUE_APP_BE + '/f_filters', {}, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_f_filters', response.data["f_filters"]);
                }, error => {
                    console.log(error);
                });
        },

        a_workflows({ state, commit, getters }, payload) {
            axios.get(process.env.VUE_APP_BE + '/workflows', {}, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_workflows', response.data["workflows"]);
                }, error => {
                    console.log(error);
                });
        },

        a_new_project({ state, commit, getters }, new_project_name) {
            axios.post(process.env.VUE_APP_BE + '/new_project', { new_project_name }, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_projects', response.data["projects"]);
                    this.dispatch('a_notify', {
                        message: 'New project has been created.',
                    }, { root: true });
                }, error => {
                    console.log(error);
                });
        },


        a_anots({ state, commit, getters }, payload) {
            // payload["cufi"] = state.cufi;
            axios.post(process.env.VUE_APP_BE + '/anots', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_transcripts', response.data["anots"]);
                }, error => {
                    console.log(error);
                });
        },

        a_show_qc({ state, commit, getters }, payload) {
            axios.post(process.env.VUE_APP_BE + '/showqc', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    if (response.data["redirect"] !== "") {
                        commit('m_qc_redirect', response.data["redirect"]);
                        let redirect = response.data["redirect"];
                        window.open(redirect, '_blank');
                    } else {
                        this.dispatch('a_notify', {
                            message: 'File is not available.',
                        }, { root: true });
                    }
                }, error => {
                    console.log(error);
                });
            // return false;
        },

        a_mongo_files({ state, commit, getters }, payload) {
            axios.post(process.env.VUE_APP_BE + '/mongo_files', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    if (response.data["redirect"] !== "") {
                        let redirect = response.data["redirect"];
                        window.open(redirect, '_blank');
                    } else if (response.data["info"] !== "") {
                        this.dispatch('a_notify', {
                            message: response.data["info"],
                        }, { root: true });
                        this.dispatch('a_project_files_data', { "id_project": state.id_project_detail });
                        this.dispatch('a_project_files_others', { "id_project": state.id_project_detail });
                    } else {

                    }
                }, error => {
                    console.log(error);
                });
        },

        a_project_files_data({ state, commit, getters }, payload) {
            axios.post(process.env.VUE_APP_BE + '/project_files_data', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_project_files_data', response.data["f_list"]);
                }, error => {
                    console.log(error);
                });
        },

        a_project_files_others({ state, commit, getters }, payload) {
            axios.post(process.env.VUE_APP_BE + '/project_files_others', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_project_files_others', response.data["f_list"]);
                }, error => {
                    console.log(error);
                });
        },

        a_change_interpretation({ state, commit, getters }, payload) {
            axios.post(process.env.VUE_APP_BE + '/change_interpretation', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {

                }, error => {
                    console.log(error);
                });
        },

        a_merge_fasta({ state, commit, getters }, payload) {
            axios.post(process.env.VUE_APP_BE + '/merge_fasta', payload, { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    this.dispatch('a_notify', {
                        message: 'FASTA FILE has been created.',
                    }, { root: true });
                }, error => {
                    console.log(error);
                });
        },

        a_overview({ state, commit, getters }, payload) {
            axios.get(process.env.VUE_APP_BE + '/dashboard', { withCredentials: true, headers: { 'Authorization': state.token, 'Content-Type': 'application/json;charset=UTF-8', } })
                .then(response => {
                    commit('m_dabo_subjects', response.data["subjects"].toString());
                    commit('m_dabo_projects', response.data["projects"].toString());
                    commit('m_dabo_examinations', response.data["examinations"].toString());
                    commit('m_dabo_lineages', response.data["lineages"].toString());

                    commit('m_dabo_pan_lineage', response.data["pan_lineage"]);
                    commit('m_dabo_next_clade', response.data["next_clade"]);

                }, error => {
                    console.log(error);
                });
        },

        a_anon_overview({ state, commit, getters }, payload) {
            axios.get(process.env.VUE_APP_BE + '/dashboard')
                .then(response => {
                    commit('m_dabo_subjects', response.data["subjects"].toString());
                    commit('m_dabo_projects', response.data["projects"].toString());
                    commit('m_dabo_examinations', response.data["examinations"].toString());
                    commit('m_dabo_lineages', response.data["lineages"].toString());

                    commit('m_dabo_pan_lineage', response.data["pan_lineage"]);
                    commit('m_dabo_next_clade', response.data["next_clade"]);

                }, error => {
                    console.log(error);
                });
        },


    },



});

export default store;
